
import {
    stopSpeech
} from "./microphone"

export const setWorldState =  (state) => {
    let sphere = document.getElementById("small-sphere")

    if (state !== "WORLD_VIEW") {
        sphere.emit("sphereopen")
    } else {
        sphere.emit("sphereclose")
    }

    return {
        type: "SET_WORLD_STATE",
        state: state
    }
}

export const setSearchState =  (state) => {

    return {
        type: "SET_SEARCH_STATE",
        state: state
    }
}

export const addSpace = (name) => {
    return {
        type: "ADD_SPACE",
        name: name,
    }
}

export const switchSpace = (id) => {
    return {
        type: "SWITCH_SPACE",
        id: id,
    }
}

export const updateSpaceName = (name, id) => {
    return {
        type: "UPDATE_SPACE_NAME",
        name: name,
        id: id,
    }
}

export const deleteSpace = (id) => {
    return {
        type: "DELETE_SPACE",
        id: id,
    }
}


export const moveBox = (index, depth) => {
    return {
        type: "MOVE_BOX",
        z: depth,
        index: index
    }
}

export const addBox = (img, x, y) => {
    let sphere = document.getElementById("small-sphere")
    sphere.emit("sphereclose")

    return {
        type: "ADD_IMAGE",
        image: img,

        x: x,
        y: y,
    }
}

export const setDrag = (index, drag) => {
    return {
        type: "SET_DRAG",
        index: index,
        drag: drag,
    }
}

export const saveDrag = (index, rotation) => {
    return {
        type: "SAVE_DRAG",

        index: index,

        x: rotation.x,
        y: rotation.y,
    }
}

export const addText = (text, x, y) => {
    let sphere = document.getElementById("small-sphere")
    sphere.emit("sphereclose")

    return {
        type: "ADD_TEXT",
        text: text,

        x: x,
        y: y
    }
}

export const rmvItem = (index) => {
    return {
        type: "REMOVE_ITEM",

        index: index
    }
}

export const clearItems = (index) => {
    return {
        type: "CLEAR_ALL",
    }
}

export const stopInput = () => {

    return (dispatch, getState) => {

        switch (getState().globalState.worldView) {

            case "WORLD_INPUT":
                dispatch( stopSpeech() )
            break;

            case "WORLD_SELECT":
                dispatch( setWorldState("WORLD_VIEW") )
            break;
            
            case "WORLD_ICON":
                dispatch( setWorldState("WORLD_VIEW") )
            break;

            case "WORLD_KEYBOARD":
                dispatch( setWorldState("WORLD_VIEW") )
            break;

            default:
            break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/index.js